module.exports = __webpack_public_path__ + "images/ds-bf-bg-footer-mobile2.webp";